export function withTimeout<T>(promise: Promise<T>, timeoutMs: number, errMsg: string): Promise<T> {
  const timeout = new Promise<never>((_, reject) => {
    const timeoutId = window.setTimeout(() => reject(new Error(errMsg)), timeoutMs);
    promise.finally(() => window.clearTimeout(timeoutId));
  });

  return Promise.race([promise, timeout]);
}
